/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import marketplaceProductTransformer from '../../transformers/marketplaceProduct';
import marketplaceProductService from '../../services/marketplaceProduct';

export default {

  props: {
    product: {
      required: true,
      type: Object,
    },
    data: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        productTypeId: {
          value: '',
          type: 'text',
        },
        image: {
          value: {},
          type: 'file',
        },
        price: {
          value: '',
          type: 'float',
        },
        shortDescription: {
          value: '',
          type: 'textarea',
        },
        longDescription: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: false,
      productMarketplace: null,
    };
  },
  created() {
    this.form.hideField('productTypeId');
    this.form.productTypeId = this.product.productTypeId;
    this.show();
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    show() {
      this.loading = true;
      marketplaceProductService.show(this.product.id)
        .then((data) => {
          this.productMarketplace = data;
          this.loading = false;
          if (data.status) {
            this.form.assignData(data);
            return;
          }
          this.form.image = this.product.icon || {};
          this.form.name = this.product.name;
          this.form.shortDescription = this.product.description;
          this.form.price = this.product.price;
        }).catch(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    /**
     * Watches product type to assign the id value
     *
     * @param  {Array} productType    The product type.
     */
    'form.productType': function (arrayValue) {
      const [productyTypeId] = arrayValue.slice(-1);
      this.form.productTypeId = productyTypeId;
    },

    'form.price': function (price) {
      this.$emit('priceUpdate', price);
    },

    product(product) {
      this.form.price = product.marketplace || this.product.price;
    },

    disabled: {
      immediate: true,
      handler(disabled) {
        Object.keys(this.form.fields).forEach((field) => {
          if (disabled) {
            this.form.disableField(field);
          } else {
            this.form.enableField(field);
          }
        });
      },
    },
    form: {
      handler(newValue) {
        this.$emit('update', newValue);
      },
      deep: true,
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/marketplaceProductForm/marketplaceProductForm.js